import { useState, useEffect, useCallback, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { callautopopulate } from "../../../services/callautopop";
import projectStore from "../../../Store/projectStore";
import services from "../../../services/services";
import { Urls } from "../../../services/Urls";
import _ from "underscore";
import { useCommon } from "../Pocker/useCommon";
import { decryptData, encryptData } from "../../../utils/encrypt";
import * as XLSX from 'xlsx';

export const useTaskDetails = ({ data }) => {
    const { lockedLayoutFields, getUserInitials } = useCommon();
    const [hoveredId, setHoveredId] = useState(null);
    const [editingId, setEditingId] = useState(null);
    const [fieldValues, setFieldValues] = useState({});
    const navigate = useNavigate()
    const containerRef = useRef(null);
    const [option, setOption] = useState({});
    const [selectedTab, setSelectedTab] = useState("Work log")
    const { projectUserList, getProjectUserList } = projectStore()
    const [expanded, setExpanded] = useState({
        "Your pinned fields": true,
        "Attachments": true,
        Details: true,
        Development: false,
        "More fields": false,
        Automation: false,
        "Key Details": true,
        "Child Items": true
    });

    const [fieldJson, setFieldJson] = useState({
        "Your pinned fields": { field: [] },
        Details: { field: [] },
        Development: { field: [] },
        "More fields": { field: [] },
        Automation: { field: [] },
    });
    const [layoutDetails, setLayoutDetails] = useState({ basicDetails: {}, api: {}, layout: {}, tab: [], worklogs: [], idHovered: false });
    const [loader, setLoader] = useState({ popup: false });
    const [userImageError, setUserImageError] = useState({});
    const [childItemRowData, setChildItemRowData] = useState([]);
    const [attachmentData, setAttachmentData] = useState([])
    const childItemColumns = [
        {
            key: "issue_key",
            label: "Key",
            style: { width: "6rem", textAlign: "center" },
            headerStyle: { textAlign: "center" },
            render: (row) => (
                <div className="d-flex gap-2 justify-content-center align-items-center">
                    <img className="rounded-circle" src={row?.image_url} alt="" width={18} height={18} />
                    <div className="fw-semibold text-primary c-pointer text-truncate" onClick={() => getTaskLayoutDetails(row?.issue_id)}>{row?.issue_key}</div>
                </div>
            )
        },
        {
            key: "issue_summary",
            label: "Summary",
            style: { width: "30rem" },
            render: (row) => <div className="text-truncate fw-semibold" title={row?.issue_summary}>{row?.issue_summary}</div>
        },
        {
            key: "user_display_name",
            label: "Assignee",
            style: { width: "2.5rem" },
            headerClass: "text-truncate",
            render: (row) => <div className="fw-semibold text-truncate d-flex gap-3 ps-1 align-items-center" title={row?.user_display_name}>
                {userImageError?.[`child_${row?.assignee_user_code}`] ? <div>{getUserInitials(row?.user_display_name, { width: 20, height: 20, fontSize: "10px" })}</div>
                    : <img className="rounded-circle" src={row?.assignee_image_url} alt="" width={20} height={20} onError={() => setUserImageError((prev) => ({ ...prev, [`child_${row?.assignee_user_code}`]: true }))} />
                }
                {row?.user_display_name}
            </div>
        },
        {
            key: "status_name",
            label: "Status",
            style: { width: "7rem" },
            render: (row) => {
                let bg = "#dddee1";
                if (row?.status_name?.toLowerCase() === 'done' || row?.status_name?.toLowerCase() === "resolved") bg = "#b3df72";
                if (row?.status_name?.toLowerCase() === 'in progress') bg = "#579dff";
                if (row?.status_name?.toLowerCase() === 'dev done') bg = "#8fb8f6";
                return <div className="px-2 text-truncate fw-semibold" style={{ width: "fit-content", maxWidth: "100%", backgroundColor: bg }} title={row?.status_name}>{row?.status_name}</div>
            }
        },
    ]
    const valueKeys = {
        datetime: "date_value",
        date: "date_value",
        number: "number_value",
        user: "text_value",
        string: "string_value",
        array: "text_value",
        option: "text_value",
        priority: "text_value",
    }

    useEffect(() => {
        callautopopulate("ticket_request_priority").then(res => {
            const priorityOptions = (res?.ticket_request_priority || []).map(p => ({
                label: p.priority_name,
                value: p.priority_name
            }));

            setOption({
                priority: priorityOptions,
                users: projectUserList?.map(p => ({
                    label: p.user_display_name,
                    value: p.user_code
                }))
            });
        });

    }, [projectUserList]);

    useEffect(() => {
        getProjectUserList(data?.project_id)
    }, [data])

    useEffect(() => {
        getTaskLayoutDetails();
    }, []);

    const getTaskLayoutDetails = async (issueId) => {
        try {
            setLoader((prev) => ({ ...prev, popup: true }));
            setUserImageError({});
            setChildItemRowData([]);
            setAttachmentData([])
            const payload = {
                issue_id: (issueId ? issueId : data?.issue_id) || 0
            }
            const res = await services.getInvokeRemote("POST", Urls("GETTASKLAYOUTDETAILS"), payload);
            if (res?.body?.error_status === false) {
                const response = _.uniq(res?.body?.data?.task_screen_details, "custom_field_id");
                const basic = res?.body?.data?.task_details;
                const worklogs = res?.body?.data?.task_activity_worklogs;
                const childItems = res?.body?.data?.child_items_details;
                const Attachments = res?.body?.data?.task_attachments
                setLayoutDetails((prev) => ({ ...prev, basicDetails: basic?.[0], worklogs: worklogs?.sort((a, b) => new Date(b?.log_datetime) - new Date(a?.log_datetime)) }));
                setChildItemRowData(childItems);
                setAttachmentData(Attachments || [])
                const grouped = _.groupBy(_.filter(response, item => item?.custom_field_key !== "subtasks"), "layout_name");
                let formatted = {};
                const pinned = JSON.parse(decryptData(localStorage.getItem("pintd")) || '{}');
                Object.entries(grouped)?.forEach(([key, value]) => {
                    if (!formatted?.[key]) {
                        formatted[key] = []
                    }
                    let convertedFieldValue = {};
                    _.sortBy(value, "order_number")?.forEach((field) => {
                        if (!Object.values(lockedLayoutFields)?.flat()?.includes(field?.custom_field_key)) {
                            const val = field?.is_static ? "static_data" : valueKeys?.[field?.schema_type];

                            // handle JSON values of fields
                            if(field?.custom_field_key === "customfield_10003") {
                                const fieldVal = field?.[val] || field?.["text_value"] || "";
                                if(fieldVal) {
                                    convertedFieldValue = {[field?.custom_field_key] : JSON.parse(fieldVal)?.[0]?.displayName};
                                }
                            }

                            if (_.pluck(pinned?.field, "custom_field_id")?.includes(field?.custom_field_id)) {
                                if (!formatted["Your pinned fields"]) formatted["Your pinned fields"] = [];
                                formatted["Your pinned fields"].push({
                                    ...field,
                                    fieldValue: convertedFieldValue[field?.custom_field_key] || field?.[val] || field?.["text_value"] || "",
                                    category: ((key === "Context Fields Optional" && (field?.[val] || field?.["text_value"])) || key === "Context Fields") ? "Details" : "More fields"
                                });
                            } else if (key === "Context Fields Optional" && (field?.[val] || field?.["text_value"])) {
                                if (!formatted["Context Fields"]) formatted["Context Fields"] = [];
                                formatted["Context Fields"].push({
                                    ...field,
                                    fieldValue: convertedFieldValue[field?.custom_field_key] || field?.[val] || field?.["text_value"] || "",
                                    order_number: Math.max(Math.max(..._.pluck(grouped?.["Context Fields"], "order_number")), Math.max(..._.pluck(formatted["Context Fields"]?.filter(item => item?.order_number), "order_number"))) + 1,
                                    category: "Details"
                                })
                            } else {
                                formatted[key].push({
                                    ...field,
                                    col: key === "Description Fields" ? (field?.schema_type === "string" ? 12 : 6) : null,
                                    fieldValue: field?.custom_field_key === "description" ? (JSONToHtml(JSON.parse(field?.[val]))) : (convertedFieldValue[field?.custom_field_key] || field?.[val] || field?.["text_value"] || ""),
                                    category: key === "Context Fields" ? "Details" : "More fields" || ""
                                })
                            }
                        }
                    })
                })
                setLayoutDetails((prev) => ({ ...prev, api: response, layout: formatted, tab: [] }));
                setFieldJson((prev) => ({
                    ...prev,
                    Details: { field: _.sortBy(formatted?.["Context Fields"], "order_number") },
                    "More fields": { field: formatted?.["Context Fields Optional"] },
                    "Your pinned fields": { field: _.sortBy(formatted?.["Your pinned fields"], "order_number") }
                }))
            }
        } catch (error) {
            console.error("Error: ", error);
        } finally {
            setLoader((prev) => ({ ...prev, popup: false }));
        }
    }

    const JSONToHtml = (node) => {
        if (!node) return "";

        switch (node?.type) {
            case "doc":
                return node?.content?.map(JSONToHtml)?.join("") || "";
            case "heading":
                return `<h4 style="font-size: 15px; font-weight: 600; margin-top: 10px">${node?.content?.map(JSONToHtml)?.join("") || ""}</h4>`;
            case "paragraph":
                return `<p class="mt-1">${node?.content?.map(JSONToHtml)?.join("") || ""}</p>`;
            case "text": {
                let text = node?.text || "";
                if (node?.marks?.length) {
                    node?.marks?.forEach((mark) => {
                        if (mark?.type === "strong") text = `<strong>${text}</strong>`;
                        if (mark?.type === "em") text = `<em>${text}</em>`;
                    });
                }
                return text;
            }
            case "bulletList":
                return `<ul>${node?.content?.map(JSONToHtml)?.join("") || ""}</ul>`;
            case "orderedList":
                return `<ol>${node?.content?.map(JSONToHtml)?.join("") || ""}</ol>`;
            case "listItem":
                return `<li>${node?.content?.map(JSONToHtml)?.join("") || ""}</li>`;
            case "table":
                return `
          <table border="1" style="border-collapse:collapse;width:100%">
            <tbody>
              ${node?.content?.map(JSONToHtml)?.join("") || ""}
            </tbody>
          </table>
        `;
            case "tableRow":
                return `<tr>${node?.content?.map(JSONToHtml)?.join("") || ""}</tr>`;
            case "tableHeader":
                return `<th style="background-color: #f5f5f5;border:1px solid #ccc;padding:8px;">${node?.content?.map(JSONToHtml)?.join("") || ""}</th>`;
            case "tableCell":
                return `<td style="padding:8px;border:1px solid #ccc;">
          ${node?.content?.map(JSONToHtml)?.join("") || ""}
        </td>`;
            case "hardBreak":
                return `<br/>`;
            case "codeBlock":
                return `<pre class="mt-3">${node?.content?.map(JSONToHtml)?.join("") || ""}</pre>`;
            default:
                return "";
        }
    };

    const handleExpand = useCallback((category) => {
        setExpanded((prev) => ({ ...prev, [category]: !prev[category], }));
    }, []);

    const handlePinToggle = (field, category) => {
        setFieldJson((prev) => {
            const pinnedFields = [...(prev?.["Your pinned fields"]?.field || [])];
            const destCategory = category === "Your pinned fields" ? field?.category : category;
            const categoryFields = [...(prev?.[destCategory]?.field || [])];

            const fieldIndex = categoryFields?.findIndex(f => f?.custom_field_id === field?.custom_field_id);

            if (fieldIndex === -1) {
                const pinnedIndex = pinnedFields?.findIndex(f => f?.custom_field_id === field?.custom_field_id);
                if (pinnedIndex > -1) {
                    const unpinnedField = pinnedFields?.splice(pinnedIndex, 1)[0];
                    categoryFields?.push(unpinnedField);
                }
            } else {
                const pinnedField = categoryFields?.splice(fieldIndex, 1)[0];
                pinnedFields?.push({ ...pinnedField, category });
            }

            localStorage.setItem("pintd", encryptData(JSON.stringify({ ...prev["Your pinned fields"], field: pinnedFields })));
            return {
                ...prev,
                "Your pinned fields": { ...prev["Your pinned fields"], field: pinnedFields },
                [destCategory]: { ...prev?.[destCategory], field: _.sortBy(categoryFields, "order_number") }
            };
        });
    };

    const handleChange = () => {

    }

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (containerRef.current && !containerRef.current.contains(event.target)) {
                setEditingId(null)
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [containerRef]);

    const GetAttachments = async (id, attachment_file_name) => {
        try {
            const payload = { "attachmentid": id };
            const res = await services.getInvokeRemote("POST", Urls("GETJIRAATTACHMENTS"), payload);
            const incomingBase64 = res?.body?.data;

            if (!incomingBase64) {
                console.warn("No attachment data received from server.");
                return;
            }
            let mimeType = '';
            const match = incomingBase64.match(/^data:([^;]+);base64,/);
            if (match) {
                mimeType = match[1];
            }

            const cleanBase64 = incomingBase64.replace(/^data:[^;]+;base64,/, "");

            if ((!mimeType || mimeType === 'application/octet-stream') && attachment_file_name) {
                const ext = attachment_file_name.split('.').pop().toLowerCase();
                const mimeMap = {
                    'txt': 'text/plain',
                    'html': 'text/html',
                    'css': 'text/css',
                    'js': 'text/javascript',
                    'json': 'application/json',
                    'pdf': 'application/pdf',
                    'png': 'image/png',
                    'jpg': 'image/jpeg',
                    'jpeg': 'image/jpeg',
                    'gif': 'image/gif',
                    'xlsx': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                    'xls': 'application/vnd.ms-excel',
                    'csv': 'text/csv'
                };
                mimeType = mimeMap[ext];
            }
            if (!mimeType) {
                const firstChar = cleanBase64.charAt(0);
                switch (firstChar) {
                    case 'U': mimeType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'; break;
                    case 'J': mimeType = 'application/pdf'; break;
                    case 'i': mimeType = 'image/png'; break;
                    case '/': mimeType = 'image/jpeg'; break;
                    case 'G': mimeType = 'image/gif'; break;
                    case 'R': mimeType = 'text/plain'; break;
                    case '0': mimeType = 'application/msword'; break;
                    default: mimeType = 'application/octet-stream';
                }
            }
            const byteCharacters = atob(cleanBase64);
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            if (mimeType === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' || mimeType === 'application/vnd.ms-excel') {
                try {
                    const workbook = XLSX.read(byteArray, { type: 'array' });
                    const firstSheetName = workbook.SheetNames[0];
                    const worksheet = workbook.Sheets[firstSheetName];
                    const htmlTableString = XLSX.utils.sheet_to_html(worksheet);
                    previewInPopup(htmlTableString, attachment_file_name);
                } catch (xlsxError) {
                    console.error("SheetJS failed to parse data as Excel.", xlsxError);
                    triggerDownload(byteArray, mimeType, attachment_file_name);
                }
            }
            else if (mimeType.startsWith('text/') || mimeType === 'application/json') {
                const decoder = new TextDecoder('utf-8');
                let textString = decoder.decode(byteArray);
                if (mimeType === 'application/json') {
                    try { textString = JSON.stringify(JSON.parse(textString), null, 4); } catch (e) { }
                }
                const escapedText = textString
                    .replace(/&/g, "&amp;")
                    .replace(/</g, "&lt;")
                    .replace(/>/g, "&gt;")
                    .replace(/"/g, "&quot;")
                    .replace(/'/g, "&#039;");

                const formattedHtml = `<pre style="white-space: pre-wrap; word-wrap: break-word;">${escapedText}</pre>`;
                previewInPopup(formattedHtml, attachment_file_name);
            }
            else if (mimeType === 'application/pdf' || mimeType.startsWith('image/')) {
                const blob = new Blob([byteArray], { type: mimeType });
                const blobUrl = URL.createObjectURL(blob);
                window.open(blobUrl, '_blank');
            }
            else {
                triggerDownload(byteArray, mimeType, attachment_file_name);
            }

        } catch (error) {
            console.error("Error generating attachment preview:", error);
        }
    };
    const triggerDownload = (byteArray, mimeType, filename) => {
        const blob = new Blob([byteArray], { type: mimeType });
        const blobUrl = URL.createObjectURL(blob);
        const downloadLink = document.createElement('a');
        downloadLink.href = blobUrl;
        downloadLink.download = filename || 'download';
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
        URL.revokeObjectURL(blobUrl);
    };

    const previewInPopup = (htmlContent, title = "Document Preview") => {
        const popup = window.open("", "_blank", "width=800,height=600,scrollbars=yes,resizable=yes");
        if (popup) {
            popup.document.write(`
            <!DOCTYPE html>
            <html>
            <head>
                <title>${title}</title>
                <style>
                    body { font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif; padding: 20px; color: #333; background-color: #fff; }
                    table { border-collapse: collapse; width: 100%; margin-top: 10px; font-size: 14px; }
                    th, td { border: 1px solid #ddd; padding: 8px; text-align: left; }
                    th { background-color: #f8f9fa; font-weight: bold; color: #212529; }
                    tr:nth-child(even) { background-color: #f9f9f9; }
                    pre { background-color: #f8f9fa; border: 1px solid #e9ecef; padding: 15px; rounded: 4px; font-family: Courier, monospace; font-size: 13px; line-height: 1.5; }
                    h3 { margin-top: 0; color: #111; }
                    hr { border: 0; border-top: 1px solid #eee; margin: 15px 0; }
                </style>
            </head>
            <body>
                <div style="overflow-x:auto;">
                    ${htmlContent}
                </div>
            </body>
            </html>
        `);
            popup.document.close();
        } else {
            alert("Popup blocked! Please allow popups for this website to view previews.");
        }
    };

    return { handleExpand, handlePinToggle, fieldJson, expanded, setExpanded, hoveredId, setHoveredId, editingId, setEditingId, handleChange, fieldValues, setFieldValues, containerRef, navigate, option, setOption, selectedTab, setSelectedTab, layoutDetails, setLayoutDetails, getTaskLayoutDetails, loader, userImageError, setUserImageError, childItemColumns, childItemRowData, getUserInitials, attachmentData, GetAttachments };
};
